export enum VIEW_STATES {
    GEO_CUBE = 'GEO_CUBE',
    SET_CUBE = 'SET_CUBE',
    NET_CUBE = 'NET_CUBE',
    POLY_CUBE = 'POLY_CUBE'
 };
 